import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Col, Form } from "react-bootstrap";
import PersonViewModel from "viewModels/notice/components/personViewModel";

const AddressInput: FunctionComponent<{
  vm: PersonViewModel;
  legal?: boolean;
}> = observer(({ vm, legal = false }) => {
  const ta = (code: string) => vm.translateAttribute("address", code);

  const controlId = `${legal ? "organization" : "home"}-address-input`;

  return (
    <Form.Row>
      <Form.Group controlId={controlId} as={Col} sm={12}>
        <Form.Label>{ta(legal ? "organizationTitle" : "title")}</Form.Label>
        <Input as="textarea" target={vm.person} property={"mailingAddress"} />
      </Form.Group>
    </Form.Row>
  );
});

export default AddressInput;
